import { IRest } from "./rest.interface";

export class CustomerPDA implements IRest {
    className = 'Planilha do Aprovado';

    document!: string;
    email!: string;
    url!: string;

    constructor(data?: any) {
        if (data) this.Deserialize(data);
    }

    Serialize() {
        const out = {
            document: this.document,
            email: this.email,
            url: this.url
        };
        return out;
    }

    Deserialize(data: any) {
        if (data) {
            this.document = data['document'] || '';
            this.email = data['email'] || '';
            this.url = data['url'] || '';
        }
        return this;
    }

}